import { useState, useEffect, useCallback } from 'react';
import { authenticatedFetch } from '../../../../utils/api';

export const useDocumentData = (deviceInfo, preloadedData = null) => {
    const [documentData, setDocumentData] = useState(preloadedData?.documentData || []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [dataFetched, setDataFetched] = useState(
        preloadedData !== null && preloadedData.documentData?.length > 0
    );

    const fetchDocumentData = useCallback(async () => {
        if (!deviceInfo) return;

        setLoading(true);
        setError(null);
        try {
            const res = await authenticatedFetch('/ManagerReport/GetDocumentData', {
                method: 'GET',
            });

            if (!res.ok) {
                throw new Error('Failed to fetch document data');
            }

            const response = await res.json();

            if (response.message != null) {
                console.log(response);
            } else {
                setDocumentData(response);
            }
        } catch (ex) {
            console.error('Error fetching document data:', ex);
            setError(ex.message);
        } finally {
            setLoading(false);
        }
    }, [deviceInfo]);

    useEffect(() => {
        if (dataFetched || !deviceInfo) return;
        fetchDocumentData().then(() => setDataFetched(true));
    }, [deviceInfo, dataFetched, fetchDocumentData]);

    return {
        documentData,
        loading,
        error,
        dataFetched,
        refresh: fetchDocumentData,
    };
};
